const SkillList = [
  "MongoDB",
  "ExpressJS",
  "Redux",
  "MS Office",
  "MS Project",
  "ERP"
];

export default SkillList;
